import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { routes } from './routes';
import 'react-phone-input-2/lib/style.css';
import 'react-multi-carousel/lib/styles.css';
import 'react-calendar/dist/Calendar.css';
import { Toaster } from 'react-hot-toast';
import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false,
};

ReactPixel.init('151157570361466', options);

function App() {
  return (
    <div>
      <Toaster position='top-right' reverseOrder={false} />
      <BrowserRouter>
        <Routes>
          {Object.values(routes).map((el) => (
            <Route
              exact
              path={el.path}
              key={el.id}
              element={<el.component />}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
